import { AxiosResponse } from "axios";
import { camelizeObject, snakizeObject } from "shared/helpers/object";
import { ApiBaseUrl, request } from "shared/clients/baseClient";
import { PaginatedResults } from "types/Query";
import { PaginationApiParams } from "@coolset/cs-ui";
import { Tags } from "../tags";

const getTags = (params: Partial<PaginationApiParams> = {}): Promise<AxiosResponse<PaginatedResults<Tags.Tag>>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/tags/`,
      method: "GET",
      params: snakizeObject(params),
    },
  }).then((data: AxiosResponse<PaginatedResults<Tags.TagApi>>) => {
    return {
      ...data,
      data: {
        ...data.data,
        results: data.data.results.map(camelizeObject<Tags.Tag>),
      },
    };
  });
};

const getTag = (id: number | string): Promise<AxiosResponse<Tags.Tag>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/tags/${id}/`,
      method: "GET",
    },
  }).then((data: AxiosResponse<Tags.TagApi>) => {
    return camelizeObject(data);
  });
};

const createTag = (params: Tags.CreateTagParams): Promise<AxiosResponse<Tags.Tag>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/tags/`,
      method: "POST",
      data: snakizeObject(params),
    },
  }).then((data: AxiosResponse<Tags.TagApi>) => {
    return camelizeObject(data);
  });
};

const deleteTag = (id: number | string) => {
  return request({
    options: {
      url: `${ApiBaseUrl}/tags/${id}/`,
      method: "DELETE",
    },
  });
};

export const tagsClient = {
  getTags,
  getTag,
  createTag,
  deleteTag,
};
